import React, { Component } from 'react'
import ClassNames from 'classnames'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import { connect } from 'react-redux'

const year = new Date().getFullYear()

class Default extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navBarOpen: false
    }
  }

  componentWillReceiveProps() {
    this.setState({ navBarOpen: false })
  }

  tabClass(tab) {
    return ClassNames({
      active: this.props.activeTab === tab
    })
  }

  toggleMenu() {
    this.setState({ navBarOpen: !this.state.navBarOpen })
  }

  render() {
    // let roleElement =[]
    // let signupElement =[]

    // if(this.props.authenticated === true) {
    //   roleElement = <ul className="nav navbar-nav navbar-right">
    //                   <li className={this.tabClass('login')}>
    //                     <Link to="/account" ><i className="fa fa-user"></i> {this.props.user}</Link>
    //                   </li>
    //                 </ul>
    // } else {
    //   signupElement = <li className={this.tabClass('signup')}>
    //                     <Link to="/signup" >註冊</Link>
    //                   </li>
    //   roleElement = <ul className="nav navbar-nav navbar-right">
    //                   <li className={this.tabClass('login')}>
    //                     <Link to="/login" ><i className="fa fa-user"></i> 登入</Link>
    //                   </li>
    //                 </ul>
    // }

    const navBarCollapse = ClassNames({
      'navbar-collapse': true,
      collapse: !this.state.navBarOpen
    })

    return (
      <div>
        <div className="navbar navbar-default navbar-fixed-top">
          <div className="container">
            <div className="navbar-header">
              <Link className="navbar-brand" to="/">
                <img className="navbar-logo" src="/media/oranwind_logo.png"  alt=""/>
                {/* <span className="navbar-brand-label">Oranwind</span> */}
              </Link>
              <button
                className="navbar-toggle collapsed"
                onClick={this.toggleMenu.bind(this)}>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
            </button>
            </div>
            <div className={navBarCollapse}>
              <ul className="nav navbar-nav">
                <li className={this.tabClass('home')}>
                  <HashLink smooth to="/#home-parallax" >首頁</HashLink>
                </li>
                <li className={this.tabClass('about')}>
                  <HashLink smooth to="/#aboutus" >關於我們</HashLink>
                </li>
                <li className={this.tabClass('product')}>
                  <HashLink smooth to="/#product" >運營品牌</HashLink>
                </li>
                <li className={this.tabClass('contact')}>
                  <HashLink smooth to="/#contact" >聯絡方式</HashLink>
                </li>
                {/* {signupElement} */}
              </ul>
              {/* {roleElement} */}
            </div>
          </div>
        </div>
        
        <div>
          {this.props.children}
        </div>

        <div className="footer">
          <div className="container">
            <span className="copyright pull-right">
              &copy; {year} Oranwind
            </span>
            <ul className="links">
              <li><HashLink smooth to="/#home-parallax" >首頁</HashLink></li>
              <li><HashLink smooth to="/#contact" >聯絡我們</HashLink></li>
            </ul>
            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.index.user,
  authenticated: state.index.authenticated,
})

export default connect(mapStateToProps, null)(Default)


// WEBPACK FOOTER //
// ./src/layouts/Default.js